export const reportEN = {
  SUBMIT: 'Submit Report',
  INFO: 'Send us a report with the error you have found'
}
